var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.address)?_c('p',[_vm._v(" Awaiting Keplr... ")]):_c('p',[_vm._v(" Account is signed in ")])])}
var staticRenderFns = []

export { render, staticRenderFns }